import {
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton
} from '@mui/material';
import Modal from './modal/modal';
import Button from './button/button';
import Close from '@mui/icons-material/Close';
import Typography from './typography/typography';
import { useTranslation } from 'react-i18next';

export const DynamicModal = ({
	open,
	onClose,
	title,
	children,
	handleSaveAction,
	buttons = [],
	...rest
}: {
	open: boolean;
	onClose: () => void;
	title: string;
	children?: React.ReactNode;
	buttons?: any[];
	handleSaveAction?: () => void;
}) => {
	const { t } = useTranslation();
	const actionButtons = buttons.length
		? [...buttons]
		: [
				{
					label: t('common.cancel'),
					onClick: onClose,
					variant: 'outlined',
					sx: {
						color: 'black !important'
					}
				},
				...(handleSaveAction
					? [
							{
								label: t('common.save'),
								onClick: handleSaveAction,
								variant: 'contained',
								color: 'primary'
							}
						]
					: [])
			];
	return (
		<Modal
			open={open}
			onClose={onClose}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			{...rest}>
			<DialogTitle
				id='alert-dialog-title'
				className='itemEntryModal--DialogTitle'>
				<Typography type='s3' color='inherit' weight='medium'>
					{t(title)}
				</Typography>
				<IconButton onClick={onClose}>
					<Close fontSize='small' />
				</IconButton>
			</DialogTitle>
			<DialogContent>{children}</DialogContent>
			<DialogActions>
				{actionButtons.map((button, index) => (
					<Button
						sx={{
							...button.sx
						}}
						key={index}
						onClick={button.onClick}
						variant={button.variant}
						color={button.color}>
						{button.label}
					</Button>
				))}
			</DialogActions>
		</Modal>
	);
};

export default DynamicModal
